'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "toolbar"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import { path } from 'rich-text-lib/utils/iterables';
import Toolbar from 'rich-text-lib/components/toolbar/Toolbar';
import { IconComponentMap, IconMap, TOGGLE_MENU_ITEM_DISABLED_STATE_EVENT_NAME } from '../constants/toolbar';
import withFindReplace from './withFindReplace';
import { isMceUI } from 'tinymce-themes/utils/dom';
import { jsx as _jsx } from "react/jsx-runtime";
class TinymceToolbar extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      uploadProgress: null,
      menuItems: {},
      contextualToolbar: [],
      contextualNodeAttributes: {},
      contextualToolbarType: undefined
    };
    this.handleUploadComplete = () => {
      this.setState({
        uploadProgress: null
      });
    };
    this.handleUploadProgress = ({
      percentLoaded
    }) => {
      this.setState({
        uploadProgress: percentLoaded
      });
    };
    this.handleWindowClick = e => {
      const {
        editor
      } = this.props;
      if (editor.editorManager.focusedEditor && !isMceUI(e.target)) {
        editor.editorManager.focusedEditor.fire('focusout');
      }
    };
    this.handleToggleMenuItemDisabledState = ({
      name,
      disabled
    }) => {
      const currentMenuItem = this.state.menuItems[name];
      if (name && currentMenuItem) {
        this.setState({
          menuItems: Object.assign({}, this.state.menuItems, {
            [name]: Object.assign({}, currentMenuItem, {
              disabled
            })
          })
        });
      }
    };
    this.handleContextualToolbarChange = ({
      contextualToolbar = [],
      contextualToolbarType,
      contextualNodeAttributes = {}
    }) => {
      this.setState({
        contextualToolbar,
        contextualToolbarType,
        contextualNodeAttributes
      });
    };
    this.convertToButton = name => {
      const button = this.props.editor.buttons[name];
      if (typeof button === 'undefined') {
        throw new Error(`[tinymce-themes] ${name} is not registered a button with TinyMCE`);
      }
      const control = typeof button === 'function' ? button() : button;
      return Object.assign({}, control, {
        name
      });
    };
    this.convertToMenuItem = name => {
      let menuItem = this.state.menuItems[name];
      if (typeof menuItem === 'undefined') {
        throw new Error(`[tinymce-themes] ${name} is not registered a menuItem with TinyMCE`);
      }
      menuItem = typeof menuItem === 'function' ? menuItem() : menuItem;
      return {
        name,
        disabled: menuItem.disabled,
        tooltip: menuItem.tooltip,
        text: menuItem.text,
        onClick: menuItem.onClick,
        render: menuItem.render,
        child: menuItem.child,
        icon: IconMap[name],
        Icon: IconComponentMap[name]
      };
    };
    this.handleMoreMenuOpenComplete = () => {
      setTimeout(() => {
        this.props.editor.nodeChanged({
          selectionChange: true
        });
      });
    };
  }
  componentDidMount() {
    // We use the "useCapture" flag here to ensure that the handler which is
    // looking for parent chrome classes still has the elements mounted
    // which would meet it's condition for not firing focus out events
    window.addEventListener('click', this.handleWindowClick, true);
    this.props.editor.on('uploadProgress', this.handleUploadProgress);
    this.props.editor.on('uploadComplete uploadFailure', this.handleUploadComplete);
    this.props.editor.on(TOGGLE_MENU_ITEM_DISABLED_STATE_EVENT_NAME, this.handleToggleMenuItemDisabledState);
    this.props.editor.on('ContextualToolbarChange', this.handleContextualToolbarChange);
    this.setState({
      menuItems: this.props.editor.menuItems
    });
  }
  componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
    this.props.editor.off('uploadProgress', this.handleUploadProgress);
    this.props.editor.off('uploadComplete uploadFailure', this.handleUploadComplete);
    this.props.editor.off(TOGGLE_MENU_ITEM_DISABLED_STATE_EVENT_NAME, this.handleToggleMenuItemDisabledState);
    this.props.editor.off('ContextualToolbarChange', this.handleContextualToolbarChange);
  }

  // The window click event is meant to handle cases where focus has moved from
  // the content editable area to a popover, or some other editor chrome which
  // is not the content editable area. At that point the internal "focusManager"
  // of TinyMCE will not handle "click aways" and we need ensure that the editor
  // focus is lost.
  render() {
    const _this$props = this.props,
      {
        editor,
        toolbar
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      contextualToolbar,
      contextualToolbarType,
      contextualNodeAttributes
    } = this.state;
    const {
      getUserAttributes,
      setUserAttribute
    } = path(['plugins', 'hscore', 'api'], editor);
    return /*#__PURE__*/_jsx(Toolbar, Object.assign({}, rest, {
      dropdownClassName: "mce-hubspot-dropdown",
      tabIndex: "-1",
      convertToButton: this.convertToButton,
      convertToMenuItem: this.convertToMenuItem,
      onMoreMenuOpenComplete: this.handleMoreMenuOpenComplete,
      uploadProgress: this.state.uploadProgress,
      getUserAttributes: getUserAttributes,
      setUserAttribute: setUserAttribute,
      toolbar: contextualToolbarType ? contextualToolbar : toolbar,
      contextualToolbarType: contextualToolbarType,
      contextualNodeAttributes: contextualNodeAttributes
    }));
  }
}
TinymceToolbar.propTypes = {
  editor: PropTypes.object.isRequired,
  toolbar: PropTypes.array.isRequired
};
export default withFindReplace(TinymceToolbar);